import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Shared by API requests and app startup without importing the app entry point.
export const msalInstance = new PublicClientApplication(msalConfig);
